// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface IsolationUnitSpec
 */
export interface IsolationUnitSpec {
  /**
   *
   * @type {string}
   * @memberof IsolationUnitSpec
   */
  cloudProvider?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitSpec
   */
  tenancy?: string;
}

/**
 * Check if a given object implements the IsolationUnitSpec interface.
 */
export function instanceOfIsolationUnitSpec(
  value: object,
): value is IsolationUnitSpec {
  return true;
}

export function IsolationUnitSpecFromJSON(json: any): IsolationUnitSpec {
  return IsolationUnitSpecFromJSONTyped(json, false);
}

export function IsolationUnitSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnitSpec {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    tenancy: json['tenancy'] == null ? undefined : json['tenancy'],
  };
}

export function IsolationUnitSpecToJSON(json: any): IsolationUnitSpec {
  return IsolationUnitSpecToJSONTyped(json, false);
}

export function IsolationUnitSpecToJSONTyped(
  value?: IsolationUnitSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    tenancy: value['tenancy'],
  };
}
